@if (isFormLoaded) {
  <form [formGroup]="formData" class="text-start">
    @for (item of controlsData; track item; let i = $index; let last = $last) {
      <div
        class="mb-3 row"
        >
        <div class="col-sm-12 mb-2">
          @if (item.label && isQuePage) {
            <label
              [for]="item.name"
              class="col-sm-12 question-label d-flex flex-wrap align-items-start"
              >
              <span class="question-number me-2">{{ i + 1 }}.</span>
              <span
                class="question-text dynamic-content title"
                [innerHtml]="item.label"
              ></span>
            </label>
          }
          @if (item.label && !isQuePage) {
            <label class="col-sm-12" [for]="item.name">
              <span class="col-form-label title" [innerHtml]="item.label"></span>
              @if (item.validators.required) {
                <span class="col-sm-2 fs-14"
                  >&nbsp;(Required)</span
                  >
                }
                @if (item.optional) {
                  <span class="col-sm-2 fs-14"
                    >&nbsp;(Optional)</span
                    >
                  }
                </label>
              }
              @if (!item.label && item.type!='hidden') {
                <label [for]="item.name" class="col-sm-12">
                  <span class="col-form-label title">Enter the text</span>
                  @if (item.validators.required) {
                    <span class="fs-14"
                      >&nbsp;(Required)</span
                      >
                    }
                    @if (item.optional) {
                      <span class="fs-14"
                        >&nbsp;(Optional)</span
                        >
                      }
                    </label>
                  }
                  @if (item.infoText != null && showTextInfo) {
                    <div class="col-sm-12">
                      <span class="col-sm-2 fs-14" [innerHtml]="item.infoText"></span>
                    </div>
                  }
                </div>
                <div class="col-sm-12" [ngClass]="customClass">
                  @if (['text', 'password', 'search', 'url'].includes(item.type)) {
                    <input
                      [placeholder]="item.placeholder ? item.placeholder : ''"
                      [type]="item.type"
                      [formControlName]="item.name"
                      class="form-control"
                      [id]="item.name"
                      [name]="item.name"
                      [value]="item.value"
                      [(ngModel)]="item.value"
                      [attr.maxlength]="item.validators.maxLength"
                      (change)="modelChangeEvent($event, item)"
                      aria-label="Text"
                      />
                  }
                  @if (item.type === 'email') {
                    <input
                      [placeholder]="item.placeholder ? item.placeholder : ''"
                      [type]="item.type"
                      class="form-control"
                      [id]="item.name"
                      [name]="item.name"
                      [value]="item.value"
                      [(ngModel)]="item.value"
                      [formControlName]="item.name"
                      (keyup)="modelChangeEvent($event, item)"
                      [readonly]="item.readonly === true"
                      />
                  }
                  @if (item.type === 'email' && isInvalidEmail) {
                    <span
                      class="error validation-color"
                      >{{ "Enter a valid email. Example: email@address.com" }}</span
                      >
                    }
                    @if (item.type === 'number') {
                      <input
                        [placeholder]="item.placeholder ? item.placeholder : ''"
                        type="text"
                        appNumberOnly
                        [formControlName]="item.name"
                        class="form-control"
                        [id]="item.name"
                        [name]="item.name"
                        [value]="item.value"
                        [ngModel]="item.value"
                        [minlength]="item?.options?.minLength ?? 0"
                        [maxlength]="item?.options?.maxLength ?? 250"
                        pattern="[0-9]*"
                        (ngModelChange)="modelChangeEvent($event, item)"
                        aria-label="Number"
                        />
                    }
                    @if (item.type === 'currency') {
                      <input
                        [placeholder]="item.placeholder ? item.placeholder : ''"
                        type="text"
                        appCurrency
                        maxDigits="9"
                        [formControlName]="item.name"
                        class="form-control"
                        [id]="item.name"
                        [name]="item.name"
                        [value]="item.value"
                        [ngModel]="item.value"
                        [minlength]="item?.options?.minLength ?? 0"
                        [maxlength]="item?.options?.maxLength ?? 250"
                        (ngModelChange)="modelChangeEvent($event, item)"
                        aria-label="Currency"
                        inputmode="decimal"
                        autocomplete="off"
                        />
                    }
                    @if (item.type === 'currency' && formData.get(item.name)?.invalid && (formData.get(item.name)?.dirty || formData.get(item.name)?.touched)) {
                      <span class="error validation-color">Enter a valid dollar amount (up to 9 digits and 2 decimals).</span>
                    }
                    @if (item.type === 'zip') {
                      <input
                        [placeholder]="item.placeholder ? item.placeholder : ''"
                        type="text"
                        appZip
                        [formControlName]="item.name"
                        class="form-control"
                        [id]="item.name"
                        [name]="item.name"
                        [(ngModel)]="item.value"
                        (ngModelChange)="modelChangeEvent($event, item)"
                        aria-label="Zip"
                        #Zip
                        />
                    }
                    @if (item.type === 'zip' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched) {
                      <span class="error validation-color">{{'Not valid, use 5 or 9 digits or numbers in this format 12345-1234.'}}</span>
                    }
                    @if (item.type === 'ssn') {
                      <input
                        [placeholder]="item.placeholder ? item.placeholder : ''"
                        type="text"
                        appSsn
                        [formControlName]="item.name"
                        [(ngModel)]="item.value"
                        (ngModelChange)="modelChangeEvent($event, item)"
                        class="form-control"
                        [id]="item.name"
                        [name]="item.name"
                        aria-label="ssn"
                        />
                    }
                    @if (item.type === 'ssn' && formData.get(item.name)?.invalid && (formData.get(item.name)?.dirty || formData.get(item.name)?.touched)) {
                      <span class="error validation-color"> Not valid, use 9 digits in format 111-22-3333 </span>
                    }
                    @if (item.type === 'fax') {
                      <input
                        [placeholder]="item.placeholder ? item.placeholder : ''"
                        type="text"
                        [formControlName]="item.name"
                        class="form-control"
                        [id]="item.name"
                        [name]="item.name"
                        [value]="item.value"
                        [(ngModel)]="item.value"
                        (keyup)="modelChangeEvent($event, item)"
                        aria-label="fax"
                        #Fax
                        />
                    }
                    @if (item.type === 'fax' && isInvalidFax) {
                      <span class="error validation-color">{{'Not valid, enter 10-digit number or use format 999-999-9999.'}}</span>
                    }
                    @if (item.type === 'date') {
                      <span class="dateFieldOnlineReferrals">
                        <p-calendar
                          placeholder="MM/DD/YYYY"
                          [formControlName]="item.name"
                          [id]="item.name"
                          [name]="item.name"
                          [(ngModel)]="item.value"
                          [minDate]="item.options.min"
                          [maxDate]="item.options.max"
                          (input)="formatDateToMMDDYYYY($event, item); onDateInput($event);modelChangeEvent($event, item)"
                          (onClearClick)="formatDateToMMDDYYYY($event, item);modelChangeEvent($event, item)"
                          (onSelect)="formatDateToMMDDYYYY($event, item);modelChangeEvent($event, item)"
                          [showButtonBar]="true"
                          [showIcon]="true"
                          [attr.required]="item.validators.required"
                          (click)="onCalendarClick()"
                          inputStyleClass="form-control"
                          [showOnFocus]="false"
                          [attr.aria-expanded]="isCalendarOpen ? 'true' : 'false'"
                          (onShow)="isCalendarOpen = true"
                          (onHide)="isCalendarOpen = false"
                        ></p-calendar>
                        <span [id]="item.name+'_Error'" style="color: red;"></span>
                      </span>
                    }
                    @if (item.type === 'phone') {
                      <input
                        type="tel"
                        [formControlName]="item.name"
                        class="form-control"
                        [id]="item.name"
                        [name]="item.name"
                        [value]="item.value"
                        [ngModel]="item.value"
                        (ngModelChange)="modelChangeEvent($event, item)"
                        aria-label="Phone"
                        />
                    }
                    @if (item.type === 'select') {
                      <select
                        [ngClass]="controlWidth ? 'form-select width45p' : 'form-select'"
                        [formControlName]="item.name"
                        aria-label="Default select example"
                        [id]="item.name"
                        [(ngModel)]="item.value"
                        (change)="onSelectChange($event, item)"
                        [name]="item.name"
                        >
                        <option value="" disabled selected>Select an option</option>
                        @for (option of item.options; track option) {
                          <option [value]="option.value">
                            {{ option.key }}
                          </option>
                        }
                      </select>
                    }
                    @if (item.type === 'textarea') {
                      <textarea
                        class="form-control"
                        [placeholder]="item.placeholder ? item.placeholder : ''"
                        [formControlName]="item.name"
                        [id]="item.name"
                        [name]="item.name"
                        [(ngModel)]="item.value"
                        (ngModelChange)="modelChangeEvent($event, item)"
        [maxlength]="
          item.validators.maxLength ? item.validators.maxLength : null
        "
                        [cols]="textAreaCol"
                        [rows]="textAreaRows"
                        aria-label="textArea"
                      ></textarea>
                    }
                    @if (item.type === 'textarea' && item?.options.showCount) {
                      <span
                        class="fs-14" [ngClass]="textAreaCounterPositionClass"
                        style="padding-top: 3px;"
                        >Character space remaining: {{ item.options.count | number }}</span
                        >
                      }
                      @if (item.type=='hidden') {
                        <input
                          type="hidden"
                          [formControlName]="item.name"
                          class="form-control"
                          [id]="item.name"
                          [name]="item.name"
                          [value]="item.value"
                          [(ngModel)]="item.value"
                          (change)="modelChangeEvent($event, item)"
                          aria-label="Text"
                          />
                      }
                    </div>
                    <div class="col-sm-2">
                      @if (item.helperText) {
                        <span class="fs-14">{{ item.helperText }}</span>
                      }
                    </div>
                    @if (isQuePage) {
                      <hr class="mt-4" />
                    }
                  </div>
                }
              </form>
            }
